<template>
  <v-container class="pt-0 d-inline-flex flex-wrap" fluid>
    <v-card class="pa-4 ma-3">
      <v-row class="mx-0 justify-space-between">
        <select-project
          v-model="projects"
          class="col-1"
          multiple
          style="min-width: 250px; max-width: 250px"
        />
        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="col-1"
          style="min-width: 250px"
        ></v-select>
        <date-picker
          v-model="from"
          label="Date From"
        />

        <date-picker
          v-model="to"
          label="Date To"
        />

        <v-btn color="info" v-on:click="search" class="mt-3 mx-3" :disabled="loading" :loading="loading">Search</v-btn>
      </v-row>
    </v-card>

    <div :key="'line-' + index" v-for="(chart, index) in charts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <default-chart :index="index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="series" :options="chart.options" :description="chart.description || ''" />
    </div>
    <div :key="'monthly-line-' + index" v-for="(chart, index) in monthlyCharts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <default-chart :index="index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="monthlySeries" :options="chart.options" :description="chart.description || ''" />
    </div>
    <div :key="`bar-` + index" v-for="(chart, index) in barCharts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <v-btn-toggle v-model="donutToggle[chart.alias]" style="z-index: 999">
        <v-btn small outlined value="false" v-html="!donutToggle[chart.alias] ? 'Bars' : 'Donut'"></v-btn>
      </v-btn-toggle>
      <bar-chart v-if="donutToggle[chart.alias]" style="margin-top: -28px" :index="'bar-' + index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="seriesByCountry" :options="chart.options" :description="chart.description || ''" />
      <donut-chart v-if="!donutToggle[chart.alias]" style="margin-top: -28px" :index="'donut-' + index" :alias="chart.alias" :title="chart.title" :donut="chart.donut" :data="chart.data" :series="seriesByCountry" :options="chart.options" :description="chart.description || ''" />
    </div>
    <div :key="`trueplay-` + index" v-for="(chart, index) in trueplayCharts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <v-btn-toggle v-model="donutToggle[chart.alias]" style="z-index: 999">
        <v-btn small outlined value="false" v-html="!donutToggle[chart.alias] ? 'Bars' : 'Donut'"></v-btn>
      </v-btn-toggle>
      <bar-chart v-if="donutToggle[chart.alias]" style="margin-top: -28px" :index="'bar-' + index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="seriesTrueplay" :options="chart.options" :description="chart.description || ''" />
      <donut-chart v-if="!donutToggle[chart.alias]" style="margin-top: -28px" :index="'donut-' + index" :alias="chart.alias" :title="chart.title" :donut="chart.donut" :data="chart.data" :series="seriesTrueplay" :options="chart.options" :description="chart.description || ''" />
    </div>

    <div class="col-12">

      <v-card>
        <v-card-text class="pb-0 pt-2">
          <v-row class="ma-0">
            <v-autocomplete
              style="z-index: 9999"
              :disabled="loading"
              label="Country"
              placeholder="All"
              v-model="levelCountry"
              item-value="code"
              item-text="code"
              :items="countries"
              :filter="filterCountry"
              class="mt-0 mr-4"
              required
              auto-select-first
              multiple
            >
              <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @click="toggleAllCountries"
                >
                  <v-list-item-action>
                    <v-icon :color="levelCountry.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:item="{ item, attrs }">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-blank-outline theme--light mr-1" v-if="!attrs.inputValue"></i>
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-marked theme--light mr-1" v-if="attrs.inputValue"></i>

                {{ item.title }} ({{ item.code }})
              </template>
            </v-autocomplete>
            <v-btn color="info" v-on:click="searchByLevel" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <div :key="`level-` + index" v-for="(chart, index) in levelCharts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <v-btn-toggle v-model="donutToggle[chart.alias]" style="z-index: 999">
        <v-btn small outlined value="false" v-html="!donutToggle[chart.alias] ? 'Bars' : 'Donut'"></v-btn>
      </v-btn-toggle>
      <bar-chart v-if="donutToggle[chart.alias]" style="margin-top: -28px" :index="'bar-' + index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="chart.data.series" :options="chart.options" :description="chart.description || ''" />
      <donut-chart v-if="!donutToggle[chart.alias]" style="margin-top: -28px" :index="'donut-' + index" :alias="chart.alias" :title="chart.title" :donut="chart.donut" :data="chart.data" :series="chart.data.series" :options="chart.options" :description="chart.description || ''" />
    </div>

    <div :key="`type-` + index" v-for="(chart, index) in typeCharts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <v-btn-toggle v-model="donutToggle[chart.alias]" style="z-index: 999">
        <v-btn small outlined value="false" v-html="!donutToggle[chart.alias] ? 'Bars' : 'Donut'"></v-btn>
      </v-btn-toggle>
      <bar-chart v-if="donutToggle[chart.alias]" style="margin-top: -28px" :index="'bar-' + index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="chart.data.series" :options="chart.options" :description="chart.description || ''" />
      <donut-chart v-if="!donutToggle[chart.alias]" style="margin-top: -28px" :index="'donut-' + index" :alias="chart.alias" :title="chart.title" :donut="chart.donut" :data="chart.data" :series="chart.data.series" :options="chart.options" :description="chart.description || ''" />
    </div>

    <div :key="`paymethod-` + index" v-for="(chart, index) in paymethodCharts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <v-btn-toggle v-model="donutToggle[chart.alias]" style="z-index: 999">
        <v-btn small outlined value="false" v-html="!donutToggle[chart.alias] ? 'Bars' : 'Donut'"></v-btn>
      </v-btn-toggle>
      <bar-chart v-if="donutToggle[chart.alias]" style="margin-top: -28px" :index="'bar-' + index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="chart.data.series" :options="chart.options" :description="chart.description || ''" />
      <donut-chart v-if="!donutToggle[chart.alias]" style="margin-top: -28px" :index="'donut-' + index" :alias="chart.alias" :title="chart.title" :donut="chart.donut" :data="chart.data" :series="chart.data.series" :options="chart.options" :description="chart.description || ''" />
    </div>
  </v-container>
</template>

<script>
  import { map } from 'lodash'

  import moment from 'moment'
  import jQuery from 'jquery'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  global.jQuery = jQuery

  export default {
    components: {
      SelectProject,
      DatePicker,
      DefaultChart: () => import('@/components/dashboard/DefaultChart'),
      BarChart: () => import('@/components/dashboard/BarChart'),
      DonutChart: () => import('@/components/dashboard/DonutChart'),
    },
    data: function () {
      return {
        dateRangeList,
        from: null,
        to: null,
        loading: false,
        projects: [],
        accountType: [ 'casino', 'sport' ],

        donutToggle: {},

        levelCountry: [],
        series: [],
        monthlySeries: [],
        seriesByCountry: [],
        seriesTrueplay: [],

        barCharts: [ {
          alias: 'active-accounts-bar',
          title: 'Active Accounts (Country)',
          description: '',
          donut: {
            label: 'country',
            value: 'current_active_accounts',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_active_accounts', 'last_active_accounts' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }, {
          alias: 'active-real-accounts-bar',
          title: 'Active Real Accounts (Country)',
          description: '',
          donut: {
            label: 'country',
            value: 'current_active_real_accounts',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_active_real_accounts', 'last_active_real_accounts' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }, {
          alias: 'ggr-bar',
          title: 'GGR (Country)',
          description: '',
          donut: {
            label: 'country',
            value: 'current_ggr',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_ggr', 'last_ggr' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }, {
          alias: 'ngr-bar',
          title: 'NGR (Country)',
          description: '',
          donut: {
            label: 'country',
            value: 'current_ngr',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_ngr', 'last_ngr' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }, {
          alias: 'registrations-bar',
          title: 'Registration (Country)',
          description: '',
          donut: {
            label: 'country',
            value: 'current_registration',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_registration', 'last_registration' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }, {
          alias: 'funded-bar',
          title: 'Funded (Country)',
          description: '',
          donut: {
            value: 'current_funded',
            label: 'country',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_funded', 'last_funded' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }, {
          alias: 'deposit-bar',
          title: 'Deposit (Country)',
          description: '',
          donut: {
            label: 'country',
            value: 'current_deposit',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_deposit', 'last_deposit' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }, {
          alias: 'withdraw-bar',
          title: 'Withdraw (Country)',
          description: '',
          donut: {
            label: 'country',
            value: 'current_withdraw',
          },
          data: {
            colors: [ '#FF6384', '#36A2EB' ],
            labels: [ 'Current Month', 'Last Month' ],
            ykeys: [ 'current_withdraw', 'last_withdraw' ],
            xkey: 'country',
            series: []
          },
          options: {}
        }
        ],

        trueplayCharts: [
          {
            alias: 'deposit-trueplay',
            title: 'Deposit trueplay (Country)',
            description: '',
            donut: {
              label: 'country',
              value: 'deposit_eur',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'deposit_eur' ],
              xkey: 'country',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          },
          {
            alias: 'withdraw-trueplay',
            title: 'Withdraw trueplay (Country)',
            description: '',
            donut: {
              label: 'country',
              value: 'withdraw_eur',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'withdraw_eur' ],
              xkey: 'country',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          },
        ],

        typeCharts: [
          {
            alias: 'deposit-paymethod-type-bar',
            title: 'Deposit by Type (EUR)',
            description: '',
            donut: {
              label: 'type',
              value: 'amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Amount' ],
              ykeys: [ 'amount' ],
              xkey: 'type',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paymethod-type-count-bar',
            title: 'Deposit by Type (deposit count)',
            description: '',
            donut: {
              label: 'type',
              value: 'deposit_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Deposit count' ],
              ykeys: [ 'deposit_count' ],
              xkey: 'type',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paymethod-type-account-bar',
            title: 'Deposit by Type (account count)',
            description: '',
            donut: {
              label: 'type',
              value: 'account_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Account count' ],
              ykeys: [ 'account_count' ],
              xkey: 'type',
              series: []
            },
            options: {}
          },
        ],

        paymethodCharts: [
          {
            alias: 'deposit-paymethod-amount-bar',
            title: 'Deposit by Paymethod (EUR)',
            description: '',
            donut: {
              label: 'paymethod',
              value: 'amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Amount' ],
              ykeys: [ 'amount' ],
              xkey: 'paymethod',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paymethod-avg-amount-bar',
            title: 'Avg Deposit by Paymethod (EUR)',
            description: '',
            donut: {
              label: 'paymethod',
              value: 'avg_deposit_amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Avg Amount' ],
              ykeys: [ 'avg_deposit_amount' ],
              xkey: 'paymethod',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paymethod-count-bar',
            title: 'Deposit by Paymethod (deposit count)',
            description: '',
            donut: {
              label: 'paymethod',
              value: 'deposit_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Deposit count' ],
              ykeys: [ 'deposit_count' ],
              xkey: 'paymethod',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paymethod-account-bar',
            title: 'Deposit by Paymethod (account count)',
            description: '',
            donut: {
              label: 'paymethod',
              value: 'account_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Account count' ],
              ykeys: [ 'account_count' ],
              xkey: 'paymethod',
              series: []
            },
            options: {}
          },
          {
            alias: 'deposit-paysystem-amount-bar',
            title: 'Deposit by Paysystem (EUR)',
            description: '',
            donut: {
              label: 'paysystem',
              value: 'amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Amount' ],
              ykeys: [ 'amount' ],
              xkey: 'paysystem',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paysystem-avg-amount-bar',
            title: 'Avg Deposit by Paysystem (EUR)',
            description: '',
            donut: {
              label: 'paysystem',
              value: 'avg_deposit_amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Avg Amount' ],
              ykeys: [ 'avg_deposit_amount' ],
              xkey: 'paysystem',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paysystem-count-bar',
            title: 'Deposit by Paysystem (deposit count)',
            description: '',
            donut: {
              label: 'paysystem',
              value: 'deposit_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Deposit count' ],
              ykeys: [ 'deposit_count' ],
              xkey: 'paysystem',
              series: []
            },
            options: {}
          }, {
            alias: 'deposit-paysystem-account-bar',
            title: 'Deposit by Paysystem (account count)',
            description: '',
            donut: {
              label: 'paysystem',
              value: 'account_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Account count' ],
              ykeys: [ 'account_count' ],
              xkey: 'paysystem',
              series: []
            },
            options: {}
          },
        ],

        levelCharts: [
          {
            alias: 'deposit-level-bar',
            title: 'Deposits by Level',
            description: '',
            donut: {
              label: 'level',
              value: 'amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'amount' ],
              xkey: 'level',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          }, {
            alias: 'avg-account-deposit-level-bar',
            title: 'Avg Account Deposits by Level',
            description: '',
            donut: {
              label: 'level',
              value: 'avg_account_amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'avg_account_amount' ],
              xkey: 'level',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          }, {
            alias: 'avg-deposit-level-bar',
            title: 'Avg Deposits by Level',
            description: '',
            donut: {
              label: 'level',
              value: 'avg_deposit_amount',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'avg_deposit_amount' ],
              xkey: 'level',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          }, {
            alias: 'avg-deposit-count-level-bar',
            title: 'Avg Deposit Count by Level',
            description: '',
            donut: {
              label: 'level',
              value: 'avg_deposit_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'avg_deposit_count' ],
              xkey: 'level',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          }, {
            alias: 'ggr-level-bar',
            title: 'GGR by Level',
            description: '',
            donut: {
              label: 'level',
              value: 'ggr_eur',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'ggr_eur' ],
              xkey: 'level',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          }, {
            alias: 'avg-ggr-level-bar',
            title: 'Avg GGR by Level',
            description: '',
            donut: {
              label: 'level',
              value: 'avg_ggr_eur',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'EUR' ],
              ykeys: [ 'avg_ggr_eur' ],
              xkey: 'level',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          }, {
            alias: 'account-ggr-level-bar',
            title: 'Accounts by Level',
            description: '',
            donut: {
              label: 'level',
              value: 'account_count',
            },
            data: {
              colors: [ '#FF6384' ],
              labels: [ 'Accounts' ],
              ykeys: [ 'account_count' ],
              xkey: 'level',
              series: []
            },
            options: { sortBy: 'label', sortDirection: [ 'desc' ] }
          },
        ],

        monthlyCharts: [
          {
            alias: 'transactions-monthly',
            title: 'Transactions Monthly',
            class: 'col-lg-12 col-sm-12',
            description: '',
            data: {
              colors: [ '#FF6384', '#36A2EB', '#00897B', '#1DE9B6' ],
              labels: [ 'Deposits', 'Withdraws' ],
              ykeys: [ 'current_deposit', 'current_withdraw' ],
              xkey: 'month',
              series: [],
              seriesKey: 'monthlySeries'
            },
            options: {}
          },
        ],
        charts: [
          {
            alias: 'registrations_funded',
            title: 'Registration/Funded',
            class: 'col-lg-12 col-sm-12',
            description: '',
            data: {
              colors: [ '#FF6384', '#36A2EB', '#00897B', '#1DE9B6' ],
              labels: [ 'Registration', 'Funded', 'Registration SPLM', 'Funded SPLM', ],
              ykeys: [ 'current_registration', 'current_funded', 'last_registration', 'last_funded' ],
              xkey: 'day',
              series: []
            },
            options: {}
          },
          {
            alias: 'transactions',
            title: 'Transactions',
            class: 'col-lg-12 col-sm-12',
            description: '',
            data: {
              colors: [ '#FF6384', '#36A2EB', '#00897B', '#1DE9B6' ],
              labels: [ 'Deposits', 'Withdraws', 'Deposits SPLM', 'Withdraws SPLM' ],
              ykeys: [ 'current_deposit', 'current_withdraw', 'last_deposit', 'last_withdraw' ],
              xkey: 'day',
              series: []
            },
            options: {}
          },
        ]

      }
    },

    computed: {
      selectedAllCountries () {
        return this.levelCountry.length === this.countries.length
      },
      selectedSomeCountries () {
        return this.levelCountry.length > 0 && !this.selectedAllCountries
      },
      icon () {
        if (this.selectedAllCountries) return 'mdi-close-box'
        if (this.selectedSomeCountries) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      countries: function () {
        return this.$store.state.app.countries
      },
    },

    mounted () {

      this.from = moment().format('YYYY-MM-01')
      this.to = moment().format('YYYY-MM-DD')
    },

    methods: {
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },
      search () {
        this.loading = true
        this.series = []
        this.monthlySeries = []
        this.seriesByCountry = []
        this.seriesTrueplay = []

        API.call('/reports/statistic.json', {
          from: this.from,
          to: this.to,
          by_entity: this.projects,
          account_type: this.accountType
        }, null, this.$store.state.auth.entities[0]).then(resp => {
          this.series = resp.data

          if (!resp.data || resp.data.length == 0) {
            return
          }
        }).finally(() => {
          this.loading = false
        })

        API.call('/$v/reports/statistic_by_trueplay.json', {
          from: this.from,
          to: this.to,
          by_entity: this.projects,
          account_type: this.accountType
        }, null, this.$store.state.auth.entities[0]).then(resp => {

          this.seriesTrueplay = resp.data

          for (let k in this.trueplayCharts) {
            if (resp.total[this.trueplayCharts[k].donut.value]) {
              this.trueplayCharts[k].description = `Total: ${resp.total[this.trueplayCharts[k].donut.value]}`
            }
          }

        })

        API.call('/reports/statistic.json', {
          from: this.from,
          to: this.to,
          by_month: true,
          months: 12,
          by_entity: this.projects,
          account_type: this.accountType
        }, null, this.$store.state.auth.entities[0]).then(resp => {
          this.monthlySeries = resp.data

          if (!resp.data || resp.data.length == 0) {
            return
          }
        }).finally(() => {
          this.loading = false
        })

        API.call('/reports/statistic.json', {
          from: this.from,
          to: this.to,
          by_country: 1,
          with_total: 1,
          by_entity: this.projects,
          account_type: this.accountType
        }, null, this.$store.state.auth.entities[0]).then(resp => {
          this.seriesByCountry = resp.data

          for (let k in this.barCharts) {
            if (resp.total[this.barCharts[k].donut.value]) {
              this.barCharts[k].description = `Total: ${resp.total[this.barCharts[k].donut.value]}`
            }
            if (this.barCharts[k].alias == 'funded-bar') {
              // this.barCharts[k].description = `Funded yersterday: ${latest.funded}, convert: ${((latest.funded / latest.registration) * 100).toFixed(2)}%`
            } else if (this.barCharts[k].alias == 'registrations-bar') {
              // this.barCharts[k].description = `Registrations yersterday: ${latest.registration}`
            }
          }
        }).finally(() => {
          this.loading = false
        })

        this.searchByLevel()

      },

      searchByLevel () {

        this.loading = true

        API.call('/$v/reports/ggr_by_level.json', {
          from: this.from,
          to: this.to,
          by_entity: this.projects,
          countries: this.levelCountry,
        }, null, this.$store.state.auth.entities[0]).then(resp => {

          for (let k in this.levelCharts) {
            if ([ 'avg-ggr-level-bar', 'ggr-level-bar', 'account-ggr-level-bar' ].includes(this.levelCharts[k].alias)) {
              this.levelCharts[k].data.series = resp.total
            }
          }
        }).finally(() => {
          this.loading = false
        })

        API.call('/$v/reports/deposit_by_level.json', {
          from: this.from,
          to: this.to,
          by_entity: this.projects,
          countries: this.levelCountry,
        }, null, this.$store.state.auth.entities[0]).then(resp => {

          for (let k in this.levelCharts) {
            if ([ 'deposit-level-bar', 'avg-account-deposit-level-bar', 'avg-deposit-level-bar', 'avg-deposit-count-level-bar' ].includes(this.levelCharts[k].alias)) {
              this.levelCharts[k].data.series = resp.total
            }
          }
        }).finally(() => {
          this.loading = false
        })

        API.call('/$v/reports/deposit_by_type.json', {
          from: this.from,
          to: this.to,
          by_entity: this.projects,
          countries: this.levelCountry,
          account_type: this.accountType
        }, null, this.$store.state.auth.entities[0]).then(resp => {
          for (let k in this.typeCharts) {
            this.typeCharts[k].data.series = resp.total
          }
        }).finally(() => {
          this.loading = false
        })

        API.call('/$v/reports/deposit_by_paymethod.json', {
          from: this.from,
          to: this.to,
          by_entity: this.projects,
          countries: this.levelCountry,
          account_type: this.accountType
        }, null, this.$store.state.auth.entities[0]).then(resp => {

          for (let k in this.paymethodCharts) {

            if ([ 'deposit-paymethod-amount-bar', 'deposit-paymethod-avg-amount-bar', 'deposit-paymethod-account-bar', 'deposit-paymethod-count-bar', 'deposit-paymethod-trueplay', 'withdraw-paymethod-trueplay' ].includes(this.paymethodCharts[k].alias)) {
              this.paymethodCharts[k].data.series = resp.paymethod || []
            }

            if ([ 'deposit-paysystem-amount-bar', 'deposit-paysystem-avg-amount-bar', 'deposit-paysystem-account-bar', 'deposit-paysystem-count-bar' ].includes(this.paymethodCharts[k].alias)) {
              this.paymethodCharts[k].data.series = resp.paysystem || []
            }

          }

        }).finally(() => {
          this.loading = false
        })

      },

      toggleAllCountries () {
        this.$nextTick(() => {
          if (this.selectedAllCountries) {
            this.levelCountry = []
          } else {
            this.levelCountry = map(this.countries.slice(), 'code')
          }
        })
      },

      filterCountry (item, queryText) {
        return (item.title.toLowerCase().includes(queryText.toLowerCase()) || item.code.toLowerCase().includes(queryText.toLowerCase()))
      },
    },
  }
</script>
